import { Component, OnInit, Input, OnChanges } from "@angular/core";
import { DialogService } from "../dialog/index";
import { DialogComponent } from "../dialog/dialog.component";
import { DataService } from "../../services/data.service"
import { environment } from "../../../../environments/environment";
import { ToolsService } from '../../../shared/services/restaurant/tools.service';

export interface PriceLevel {
  title: string;
  Items: any;
}

@Component({
  selector: 'app-sellingpricelevelmapping-popup',
  templateUrl: './sellingpricelevelmapping-popup.component.html',
  styleUrls: ['./sellingpricelevelmapping-popup.component.css']
})
export class SellingPriceLevelMappingPopUpComponent extends DialogComponent<PriceLevel, boolean>
  implements PriceLevel, OnInit, OnChanges {

  title: string;
  Items: any = [];
  result: any = { result: false, RtnItem: {} };
  @Input() popup: boolean = true;

  loading: boolean = false
  SelectAllLocation: boolean = false;
  selectedItem: any = [];
  LevelSearchText: string = "";
  LocationSearchText: string = "";
  FilteredItemDetails: any = [];

  constructor(dialogService: DialogService, private ds: DataService, private ts: ToolsService) {
    super(dialogService);
  }

  ngOnChanges() {

  }
  ngOnInit() {
   this.FilteredItemDetails=this.Items;
  }

  selectAllLoc(e) {
    if (e.target.checked) {
      for (let i of this.Items) {
        i.Selected = true;
        this.SelectAllLocation = true;
      }
    }
    else {
      for (let i of this.Items) {
        this.SelectAllLocation = false;
        i.Selected = false;
      }
    }

  }

  selectChange(e, v) {
    if (e.target.checked) {
      this.Items.find(x => x.ToLevelId == v.ToLevelId && x.ToLocId == v.ToLocId).Selected = true;

    }
    else {
      this.Items.find(x => x.ToLevelId == v.ToLevelId && x.ToLocId == v.ToLocId).Selected = false;
      this.SelectAllLocation = false;
    }

    for (let i of this.Items) {
      if (i.Selected == false) {
        this.SelectAllLocation = false;
        break;
      } else {
        this.SelectAllLocation = true;
      }

    }
  }

  validateItem(): boolean {
    this.selectedItem = [];
    for (let i of this.Items) {
      if (i.Selected) {
        this.selectedItem.push(i);
      }
    }
    if (this.selectedItem.length == 0) {
      alert("Please select a row");
      return false;
    }
    return true;
  }

  savePriceLevel() {
    var confMsg = confirm("Do you want to save this Item ?");
    if (confMsg) {
      if (this.validateItem()) {
        this.loading = true;

        this.ts.Save_LocationPriceLevelMapping(this.selectedItem).subscribe(res => {
          if (res.Success) {
            alert("Price Level Saved Successfully");
            this.result.result = true;
            this.loading = false;
            this.close();
          }
          else {
            alert(res.error.UsrMsg);
            this.loading = false;
          }
        });
      }
    }

  }

  cancel() {
    this.Items = [];
    this.close();
  }

    LevelSearchTextKeydown(e) {
    if (!this.LevelSearchText || this.LevelSearchText == "") {
      this.FilteredItemDetails = this.Items;
      return;
    }

    this.FilteredItemDetails = this.Items.filter(it =>
      it.ToLevelName.toLowerCase().includes(this.LevelSearchText.toLowerCase())
    );
  }

  LocationSearchTextKeydown(e) {
    if (!this.LocationSearchText || this.LocationSearchText == "") {
      this.FilteredItemDetails = this.Items;
      return;
    }

    this.FilteredItemDetails = this.Items.filter(item =>
      item.ToLocationName.toLowerCase().includes(this.LocationSearchText.toLowerCase())
    );
  }


}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/iPOSERP/src/app/shared/component/sellingpricelevelmapping-popup/sellingpricelevelmapping-popup.component.ts